import { httpGet, httpPost } from 'core/restClient'
import { takeLatest, put, delay } from 'redux-saga/effects'
import { appLoading, appLoaded, toastError } from 'ducks/app'
import { createReducer, makeAction, makeKeys } from 'ducks/helper'

const createKeys = (key) => makeKeys(`QR_${key}`)

const CLEAR_QR_DATA = createKeys('CLEAR_QR_DATA')
export const clearQrData = makeAction(CLEAR_QR_DATA.REQUEST, 'qrValue')

const SUBMIT_QR_CODE = createKeys('SUBMIT_QR_CODE')
export const submitQrCode = makeAction(SUBMIT_QR_CODE.REQUEST, 'qrValue')
const submitQrCodeSuccess = makeAction(SUBMIT_QR_CODE.SUCCESS, 'data')
function* submitQrCodeRequest(action) {
  const { qrValue } = action.payload
  try {
    yield put(appLoading('Submit billing data.'))
    const response = yield httpGet('qr', { qrValue })
    yield put(appLoaded())
    yield put(submitQrCodeSuccess(response.data))
  }
  catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

const GET_BILLING_SCAN_DETAIL = createKeys('GET_BILLING_SCAN_DETAIL')
export const getBillingScanDetail = makeAction(GET_BILLING_SCAN_DETAIL.REQUEST, 'id', 'isBuyer')
const getBillingScanDetailSuccess = makeAction(GET_BILLING_SCAN_DETAIL.SUCCESS, 'data')
function* getBillingScanDetailRequest(action) {
  const { id, isBuyer } = action.payload
  try {
    yield put(appLoading())
    const token = localStorage.getItem('accessToken')
    if(!token) yield delay(2000) //delay for get token from msal
    const response = yield httpGet(`qr/bl/${id}`, { isBuyer:isBuyer })
    yield put(appLoaded())
    yield put(getBillingScanDetailSuccess(response.data))
  }
  catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

const CONFIRM_BILLING_SCAN = createKeys('CONFIRM_BILLING_SCAN')
export const confirmBillingScan = makeAction(CONFIRM_BILLING_SCAN.REQUEST, 'id', 'isBuyer', 'callBack')
function* confirmBillingScanRequest(action) {
  const { id, isBuyer, callBack } = action.payload
  try {
    yield put(appLoading())
    yield httpPost(`qr/bl/${id}/confirm?isBuyer=${isBuyer}`)
    yield put(appLoaded('Scan success'))
    if(callBack)callBack(true)
  }
  catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
    if(callBack)callBack(false)
  }
}

export function* watchQrSaga() {
  yield takeLatest(SUBMIT_QR_CODE.REQUEST, submitQrCodeRequest)
  yield takeLatest(GET_BILLING_SCAN_DETAIL.REQUEST, getBillingScanDetailRequest)
  yield takeLatest(CONFIRM_BILLING_SCAN.REQUEST, confirmBillingScanRequest)
}

const initial = {
  qrData: { },
  qrBillingData: { }
}

const validateClearData = (data, qrValue) => {
  const { documentNumber } = data

  if (documentNumber) {
    if (qrValue.indexOf(documentNumber) !== -1 ) {
      return {}
    }
  }
  return data
}

export default createReducer(initial, state => ({
  [SUBMIT_QR_CODE.REQUEST]: () => ({
    ...state, 
    qrData: {},
  }),
  [SUBMIT_QR_CODE.SUCCESS]: (data) => ({
    ...state, 
    qrData: data.data,
  }),
  [GET_BILLING_SCAN_DETAIL.REQUEST]: () => ({
    ...state, 
    qrBillingData: {},
  }),
  [GET_BILLING_SCAN_DETAIL.SUCCESS]: (data) => ({
    ...state, 
    qrBillingData: data.data,
  }),
  [CLEAR_QR_DATA.REQUEST]: (data) => ({
    ...state, 
    qrData: validateClearData(state.qrData, data.qrValue),
  }),
}))
